import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 3.5rem;
  padding-top: 5rem;
  color: white;
  text-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
`;
